"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryGetNextPageParams = void 0;
var core_1 = require("@moralisweb3/core");
var tryGetNextPageParams = function (firstPageIndex, currentParams, result) {
    if (firstPageIndex !== 0 && firstPageIndex !== 1) {
        throw new core_1.MoralisApiError({
            message: 'Not supported firstPageIndex. Value can only be 0 or 1',
            code: core_1.ApiErrorCode.NOT_IMPLEMENTED,
        });
    }
    var currentPage = firstPageIndex === 1 ? result.page : result.page + 1;
    var hasNextPage = result.total > result.page_size * currentPage;
    if (!hasNextPage) {
        return null;
    }
    var nextParams = __assign({}, currentParams);
    if (result.cursor) {
        nextParams.cursor = result.cursor;
    }
    else {
        nextParams.offset = (result.page + 1) * (nextParams.limit || 500);
    }
    return nextParams;
};
exports.tryGetNextPageParams = tryGetNextPageParams;
